<template>
  <div>
    <!-- 使用公共导航栏组件 -->
    <Nav />

    <!-- 主要内容区 - 单据样式 -->
    <div class="max-w-5xl mx-auto px-4 pb-12 pt-24">
      <!-- 单据容器 -->
      <div class="bg-white border border-gray-300 shadow-lg rounded-sm">
        <!-- 单据头部 -->
        <div class="border-b-2 border-gray-800 p-6 bg-gray-50">
          <div class="flex flex-col md:flex-row justify-between items-center">
            <div class="text-center md:text-left mb-4 md:mb-0">
              <h1 class="text-3xl font-bold text-gray-900">租赁预订单</h1>
              <p class="text-gray-600 mt-1">
                可根据需求进行增减设备，修改后点击【保存预订单】。
              </p>
            </div>
            <div class="flex flex-col items-end">
              <div class="text-gray-700 font-medium">
                订单编号：{{ orderInfo.order_number || "待填写" }}
              </div>
              <div class="text-gray-600 text-sm">
                <ExportPrintTools
                    :orderInfo="orderInfo"
                    :itemsByCategory="itemsByCategory"
                    :totalAmount="totalAmount"
                    :totalItemsCount="totalItemsCount"
                  />
              </div>
            </div>
          </div>
        </div>

        <!-- 单据信息区域 -->
        <div class="p-6">
          <!-- 客户信息 -->
          <div class="grid grid-cols-1 md:grid-cols-2 gap-6 mb-6">
            <div>
              <h3
                class="text-gray-700 font-medium border-b border-gray-200 pb-2 mb-3"
              >
                客户信息
              </h3>
              <div class="text-gray-600 space-y-2">
                <div>
                  收货人：{{ orderInfo.recipient_name || "待填写" }}
                </div>
                <div>联系电话：{{ orderInfo.recipient_phone || "待填写" }}</div>
                <div>收货人地址：{{ orderInfo.recipient_address || "待填写" }}</div>
              </div>
            </div>
            <div>
              <h3
                class="text-gray-700 font-medium border-b border-gray-200 pb-2 mb-3"
              >
                活动信息
              </h3>
              <div class="text-gray-600">
                <div class="mb-2">活动地点：{{ activityInfo.location || "待填写" }}</div>
                <div class="grid grid-cols-2 gap-2 mb-2">
                  <div>开始日期：{{ activityInfo.start_date || "待选择" }}</div>
                  <div>结束日期：{{ activityInfo.end_date || "待选择" }}</div>
                </div>
                <div class="grid grid-cols-2 gap-2 mb-2">
                  <div>
                    活动类型：{{ activityInfo.activity_type || "待选择" }}
                  </div>
                  <div>
                    活动人数：{{ activityInfo.people_count || "待填写" }}
                  </div>
                </div>
                <div>活动地点：{{ activityInfo.location || "待填写" }}</div>
              </div>
            </div>
          </div>

          <!-- 空状态 -->
          <div
            v-if="selectedItems.length === 0"
            class="border border-dashed border-gray-300 p-12 text-center"
          >
            <i class="ri-file-list-line text-4xl text-gray-300 mb-4"></i>
            <p class="text-gray-500 mb-4">暂无设备信息，请添加租赁设备</p>
            <button
              class="bg-primary text-white py-2 px-6 rounded hover:bg-primary/90 transition-colors"
              @click="showEquipmentSelector = true"
            >
              <i class="ri-add-circle-line mr-2"></i>添加设备
            </button>
          </div>

          <!-- 设备清单表格 -->
          <div v-else>
            <div class="flex justify-between items-center mb-4">
              <h3 class="text-gray-700 font-medium">设备清单</h3>
              <div class="flex space-x-3">

                  <button
                    class="text-sm text-primary hover:text-primary/80 flex items-center"
                    @click="showEquipmentSelector = true"
                  >
                    <i class="ri-add-line mr-1"></i>添加设备
                  </button>
                </div>
            </div>

            <!-- 按分类分组 -->
            <div
              v-for="(group, categoryName) in itemsByCategory"
              :key="categoryName"
              class="mb-6"
            >
              <div
                class="bg-gray-50 p-2 pl-4 border-l-4 border-primary text-gray-700 font-medium"
              >
                分类: {{ categoryName }}
              </div>

              <table class="min-w-full border border-gray-300 mb-2">
                <thead class="bg-gray-50">
                  <tr>
                    <th
                      class="py-3 px-4 text-left text-xs font-medium text-gray-500 uppercase tracking-wider border-b border-r border-gray-300 w-12"
                    >
                      序号
                    </th>
                    <th
                      class="py-3 px-4 text-left text-xs font-medium text-gray-500 uppercase tracking-wider border-b border-r border-gray-300 w-48"
                    >
                      设备信息
                    </th>
                    <th
                      class="py-3 px-4 text-center text-xs font-medium text-gray-500 uppercase tracking-wider border-b border-r border-gray-300 w-32"
                    >
                      金额(元/天)
                    </th>
                    <th
                      class="py-3 px-4 text-center text-xs font-medium text-gray-500 uppercase tracking-wider border-b border-r border-gray-300 w-16"
                    >
                      数量
                    </th>
                    <th
                      class="py-3 px-4 text-center text-xs font-medium text-gray-500 uppercase tracking-wider border-b border-r border-gray-300 w-16"
                    >
                      天数
                    </th>
                    <th
                      class="py-3 px-4 text-center text-xs font-medium text-gray-500 uppercase tracking-wider border-b border-r border-gray-300 w-16"
                    >
                      小计(元)
                    </th>
                    <th
                      class="py-3 px-4 text-center text-xs font-medium text-gray-500 uppercase tracking-wider border-b border-gray-300 w-16"
                    >
                      操作
                    </th>
                  </tr>
                </thead>
                <tbody class="bg-white divide-y divide-gray-200">
                  <tr v-for="(item, index) in group" :key="item.sku_id">
                    <td
                      class="py-3 px-4 text-sm text-gray-500 border-r border-gray-200"
                    >
                      {{ index + 1 }}
                    </td>
                    <td
                      class="py-3 px-4 text-sm text-gray-900 border-r border-gray-200"
                    >
                      <div class="flex items-center">
                        <img
                          :src="item.thumbnail_url"
                          :alt="item.name"
                          class="w-12 h-12 object-cover rounded mr-3"
                        />
                        <div>
                          <div class="font-medium">{{ item.name }}</div>
                          <div class="text-xs text-gray-500">
                            {{ item.spec_text }}
                          </div>
                        </div>
                      </div>
                    </td>
                    <td
                      class="py-3 px-4 text-sm text-gray-500 border-r border-gray-200 text-center"
                    >
                      {{ item.price }}
                    </td>
                    <td class="py-3 px-4 border-r border-gray-200">
                      <div class="flex items-center justify-center">
                        <button
                          class="w-6 h-6 bg-gray-200 rounded flex items-center justify-center text-gray-600 hover:bg-gray-300"
                          @click="updateItemQuantity(item.sku_id, -1)"
                          :disabled="item.quantity <= 1"
                        >
                          <i class="ri-subtract-line text-xs"></i>
                        </button>
                        <span class="w-8 text-center">{{ item.quantity }}</span>
                        <button
                          class="w-6 h-6 bg-gray-200 rounded flex items-center justify-center text-gray-600 hover:bg-gray-300"
                          @click="updateItemQuantity(item.sku_id, 1)"
                        >
                          <i class="ri-add-line text-xs"></i>
                        </button>
                      </div>
                    </td>
                    <td
                      class="py-3 px-4 text-sm text-gray-500 border-r border-gray-200 text-center"
                    >
                      {{ orderInfo.rental_days }}
                    </td>
                    <td
                      class="py-3 px-4 text-sm font-medium text-gray-900 border-r border-gray-200 text-center"
                    >
                      ¥{{
                        (
                          item.price *
                          item.quantity *
                          orderInfo.rental_days
                        ).toFixed(2)
                      }}
                    </td>
                    <td class="py-3 px-4 text-center">
                      <button
                        class="text-red-500 hover:text-red-700"
                        @click="removeItem(item.sku_id)"
                      >
                        <i class="ri-delete-bin-line"></i>
                      </button>
                    </td>
                  </tr>
                </tbody>
              </table>

              <div class="flex justify-end">
                <button
                  class="text-xs text-gray-500 hover:text-red-500"
                  @click="removeAllByCategory(categoryName)"
                >
                  清空该分类设备
                </button>
              </div>
            </div>
          </div>
        </div>

        <!-- 单据底部 -->
        <div
          v-if="selectedItems.length > 0"
          class="bg-gray-50 border-t border-gray-300 p-6"
        >
          <div class="flex justify-end mb-6">
            <div class="text-right space-y-2">
              <div class="text-gray-600 flex items-center justify-end">
                <span class="w-32">设备总数：</span>
                <span class="font-medium">{{ totalItemsCount }} 件</span>
              </div>
              <div class="text-gray-600 flex items-center justify-end">
                <span class="w-32">预估天数：</span>
                <span class="font-medium">{{ orderInfo.rental_days }} 天</span>
              </div>
              <div
                class="border-t border-gray-300 pt-2 mt-2 flex items-center justify-end"
              >
                <span class="w-32 text-lg font-medium text-gray-900"
                  >总计：</span
                >
                <span class="text-xl font-bold text-primary"
                  >¥{{ totalAmount.toFixed(2) }}</span
                >
              </div>
            </div>
          </div>

          <!-- 操作按钮 -->
          <div
            class="flex justify-between items-center border-t border-gray-300 pt-4"
          >
            <div class="text-sm text-gray-500">
              <i class="ri-info-line mr-1"></i>
              以上价格为预估价格，最终以实际结算为准
            </div>
            <div class="flex space-x-3">
              <button
                class="px-6 py-2 border border-gray-300 rounded hover:bg-gray-50 transition-colors"
                @click="savePreOrder"
              >
                保存预订单
              </button>
              <button
                class="px-6 py-2 bg-primary text-white rounded hover:bg-primary/90 transition-colors font-medium"
                @click="goToCashier"
              >
                提交成正式订单并结算
              </button>
            </div>
          </div>
        </div>
      </div>

      <!-- 单据说明 -->
      <div
        class="mt-6 text-sm text-gray-500 bg-gray-50 p-4 rounded border border-gray-200"
      >
        <h4 class="font-medium text-gray-700 mb-2">预订单说明：</h4>
        <ol class="list-decimal list-inside space-y-1 pl-2">
          <li>此预订单仅作为租赁意向确认，均可根据需求进行修改</li>
          <li>修改预订单后，需点击【保存预订单】才能生效</li>
          <li>点击【提交成正式订单并结算】后，将转为正式订单，用户需登录</li>
          <li>有任何问题，请联系您的专属客服： {{ orderInfo.serve_name }} {{ orderInfo.serve_phone }}</li>
        </ol>
      </div>
    </div>

    <!-- 租赁设备选择器组件 -->
    <GoodsSelector
      :visible="showEquipmentSelector"
      :on-close="handleCloseEquipmentSelector"
      :on-add-item="handleAddItem"
    />

    <!-- 使用公共页脚组件 -->
    <Footer />
  </div>
</template>

<script>
import Nav from "@/components/Nav.vue";
import Footer from "@/components/Footer.vue";
import GoodsSelector from "@/components/GoodsSelector.vue";
import ExportPrintTools from "@/components/ExportPrintTools.vue";
import api from "@/utils/api";
import { formatDate } from "@/utils/tool";

export default {
  name: "PreOrder",
  components: {
    Nav,
    Footer,
    GoodsSelector,
    ExportPrintTools
  },
  data() {
    return {
      showEquipmentSelector: false,
      selectedItems: [],
      customerInfo: {
        name: "",
        phone: "",
        email: "",
      },
      rentalInfo: {
        startDate: "",
        endDate: "",
        location: "",
      },
      orderInfo: {},
      activityInfo: {},
    };
  },
  computed: {
    // 按分类分组的设备
    itemsByCategory() {
      const groups = {};
      this.selectedItems.forEach((item) => {
        // 获取分类名称，如果没有则使用"未分类"
        const categoryName = item.category_name || item.category || "未分类";
        if (!groups[categoryName]) {
          groups[categoryName] = [];
        }
        groups[categoryName].push(item);
      });
      return groups;
    },

    // 计算预订单中的设备总数
    totalItemsCount() {
      return this.selectedItems.reduce((total, item) => {
        return total + item.quantity;
      }, 0);
    },

    // 计算预订单总金额
    totalAmount() {
      return this.selectedItems.reduce((total, item) => {
        return total + item.price * item.quantity * this.orderInfo.rental_days;
      }, 0);
    },
  },
  methods: {
    // 导出设备清单


    // 加载预订单数据
    async loadPreOrderData() {
      try {
        const preorderNumber = this.$route.params.preorderNumber;
        const response = await api.order.getPreOrder({
          preorderNumber: preorderNumber,
        });
        this.orderInfo = response.data || {};
        this.selectedItems = this.orderInfo.order_items || [];
        this.activityInfo = this.orderInfo.activity || {};
      } catch (error) {
        console.error("加载预订单数据失败:", error);
      }
    },

    // 保存预订单数据到后端
    async savePreOrderData() {
      try {
        const preOrderData = {
          selectedItems: this.selectedItems,
          preorderNumber: this.$route.params.preorderNumber,
          totalAmount: this.totalAmount,
        };
        const res = await api.order.savePreOrder(preOrderData);
      } catch (error) {
        console.error("保存预订单数据失败:", error);
      }
    },

    // 关闭设备选择器
    handleCloseEquipmentSelector() {
      this.showEquipmentSelector = false;
    },

    // 添加设备到已选列表
    handleAddItem(item) {
      const existingItem = this.selectedItems.find(
        (i) => i.sku_id === item.sku_id
      );

      if (existingItem) {
        existingItem.quantity += 1;
        this.$message.success(
          `已将${item.name}数量增加到${existingItem.quantity}`
        );
      } else {
        // 为设备添加必要信息
        const itemWithCategory = {
          ...item,
          quantity: 1,
          category_name: item.category_name || item.category || "未分类",
        };
        this.selectedItems.push(itemWithCategory);
        this.$message.success(`已将${item.name}加入预订单`);
      }

      this.showEquipmentSelector = false;
    },

    // 更新设备数量
    updateItemQuantity(skuId, change) {
      const itemIndex = this.selectedItems.findIndex(
        (item) => item.sku_id === skuId
      );
      if (itemIndex !== -1) {
        const newQuantity = this.selectedItems[itemIndex].quantity + change;
        if (newQuantity > 0) {
          this.selectedItems[itemIndex].quantity = newQuantity;
        } else {
          this.removeItem(skuId);
        }
      }
    },

    // 移除设备
    removeItem(skuId) {
      const itemIndex = this.selectedItems.findIndex(
        (item) => item.sku_id === skuId
      );
      if (itemIndex !== -1) {
        const itemName = this.selectedItems[itemIndex].name;
        this.selectedItems.splice(itemIndex, 1);
        this.$message.success(`已从预订单移除${itemName}`);
      }
    },

    // 清空某分类下的所有设备
    removeAllByCategory(categoryName) {
      const categoryItems = this.selectedItems.filter(
        (item) =>
          (item.category_name || item.category || "未分类") === categoryName
      );

      if (categoryItems.length > 0) {
        this.selectedItems = this.selectedItems.filter(
          (item) =>
            (item.category_name || item.category || "未分类") !== categoryName
        );
        this.$message.success(`已清空${categoryName}分类下的所有设备`);
      }
    },

    // 格式化当前日期
    formatDate(date, format = "YYYY-MM-DD") {
      return formatDate(date, format);
    },

    // 保存预订单
    savePreOrder() {
      if (this.selectedItems.length === 0) {
        this.$message.warning("预订单为空，无法保存");
        return;
      }

      this.savePreOrderData();
      this.$message.success("预订单已保存");
    },

    // 去结算
    goToCashier() {
      if (this.selectedItems.length === 0) {
        this.$message.warning("预订单为空，无法结算");
        return;
      }

      // 保存预订单数据并跳转到确认订单页面
      this.savePreOrderData();
      // 延迟跳转，让用户看到成功提示
      setTimeout(() => {
        this.$router.push({
          name: "Cashier",
          params: {
            orderNumber: this.$route.params.preorderNumber,
            paymentMethod: this.orderInfo.paymentMethod,
          },
        });
      }, 1000);
    },
  },
  mounted() {
    // 加载预订单数据
    this.loadPreOrderData();
  },
};
</script>

<style scoped>
/* 单据样式 */
button:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}

button:disabled:hover {
  background-color: inherit !important;
}
</style>



// WEBPACK FOOTER //
// src/pages/order/PreOrder.vue